import { render, staticRenderFns } from "./PaymentAmeDetails.vue?vue&type=template&id=8a9e50d2&scoped=true&"
import script from "./PaymentAmeDetails.vue?vue&type=script&lang=js&"
export * from "./PaymentAmeDetails.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAmeDetails.vue?vue&type=style&index=0&id=8a9e50d2&scoped=true&lang=css&"
import style1 from "./PaymentAmeDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a9e50d2",
  null
  
)

export default component.exports